import React, { useState, useEffect } from "react";
import { cn } from "../utils";
import edit from '../assets/images/icon/edit.png';
import view from '../assets/images/icon/eye-scan.png';
import Pagination from "./Pagination";

const Table = React.forwardRef(({
    style,
    containerStyle,
    headers,
    data,
    className,
    handleView,
    handleEdit,
    handleDelete,
    handleToggleActive,
    showPagination = true,
    pageSize = 10,
    containerClassName = "",
    ...rest
}, ref) => {
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => { setCurrentPage(1); }, [data.length]);

    const totalPages = Math.max(1, Math.ceil(data.length / pageSize));
    const paginatedData = showPagination
        ? data.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        : data;

    return (
        <>
            <div className={cn("table-container", containerClassName)} style={{ ...containerStyle }}>
                <table ref={ref} className={cn("table custom-table", className)} {...rest}>
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th key={cn(header?.headerName, String(index))}>{header?.headerName}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.map((d, index) => (
                            <tr key={index} className="table-data-row">
                                {headers.map((header, hIndex) => {
                                    const value = d?.[header?.key];
                                    return (
                                        <td key={cn(header?.key, String(hIndex))}>
                                            {header?.renderValue ? (
                                                header?.renderValue(d)
                                            ) : (
                                                <>
                                                    {header.key !== "action" ? (
                                                        <span className={
                                                            header?.key === "active_status" ? "active"
                                                            : header?.key === "onboard_status"
                                                                ? value === "Completed" ? "complete"
                                                                : value === "Need Attention" ? "need-attention" : ""
                                                            : ""
                                                        }>
                                                            {value ?? '—'}
                                                        </span>
                                                    ) : (
                                        <div className="d-flex gap-4 align-items-center">
                                            <img src={edit} alt="Edit" style={{ cursor: 'pointer' }} onClick={() => handleEdit && handleEdit(d)} />
                                            <img src={view} alt="View" style={{ cursor: 'pointer' }} onClick={() => handleView && handleView(d)} />
                                            {handleDelete && (
                                                <span title="Delete" style={{ cursor: 'pointer', display: 'inline-flex' }} onClick={() => handleDelete(d)}>
                                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#c62828" strokeWidth="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                                                </span>
                                            )}
                                            {handleToggleActive && (
                                                <span
                                                    title={d.active === false ? "Activate" : "Deactivate"}
                                                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                                                    onClick={() => handleToggleActive(d)}
                                                >
                                                    {d.active === false ? (
                                                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.2" title="Activate"><path d="M18.36 6.64A9 9 0 1 1 5.64 5.64"/><line x1="12" y1="2" x2="12" y2="12"/></svg>
                                                    ) : (
                                                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#c62828" strokeWidth="2.2" title="Deactivate"><path d="M18.36 6.64A9 9 0 1 1 5.64 5.64"/><line x1="12" y1="2" x2="12" y2="12"/></svg>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {showPagination && totalPages > 1 && (
                <Pagination
                    style={{ marginTop: "14px" }}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                />
            )}
        </>
    );
});

Table.displayName = "Table";
export default Table;



